import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

const buildParams = (filters = {}, pageNumber = 0, pageSize = 5) => {
  const params = { pageNumber, pageSize };
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  if (filters.startMonth) params.startMonth = filters.startMonth;
  if (filters.endMonth) params.endMonth = filters.endMonth;
  if (filters.projectId) params.projectId = filters.projectId;
  if (filters.status) params.status = filters.status;
  if (filters.quotaMonth) params.quotaMonth = filters.quotaMonth;
  if (filters.empId) params.empId = filters.empId;
  return params;
};

export const addRemoteOfficeHoursTask = async (payload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/remote-office-hours/tasks`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const approveRemoteOfficeHoursTask = async (task) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/remote-office-hours/tasks`,
      task,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response);
  }
};

export const getRemoteOfficeHoursTasks = async (
  employeeId,
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/tasks/users/${employeeId}`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getRemoteOfficeHoursTasksForManager = async (
  managerId,
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/tasks/manager/${managerId}`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const deleteRemoteOfficeHoursTask = async (taskId, employeeId) => {
  try {
    const response = await _axios.delete(
      `${WORKFLOW_PATH}/remote-office-hours/tasks/${taskId}/user/${employeeId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const requestRemoteOfficeHoursQuota = async (payload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const decideRemoteOfficeHoursQuota = async (payload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const getRemoteOfficeHoursQuotaRequests = async (
  employeeId,
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests/users/${employeeId}`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getRemoteOfficeHoursQuotaRequestsForManager = async (
  managerId,
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests/manager/${managerId}`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getRemoteOfficeHoursQuotaBalance = async (employeeId, date) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/quota-balance/users/${employeeId}`,
      { params: date ? { date } : {} },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const cancelRemoteOfficeHoursQuota = async (id, employeeId) => {
  try {
    const response = await _axios.delete(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests/${id}/user/${employeeId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getRemoteOfficeHoursQuotaRequestsForReportingManager = async (
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/remote-office-hours/quota-requests/reporting-manager/me`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
